import Vue from 'vue'
import App from './App.vue'

import '@ungap/custom-elements'
import vueCustomElement from 'vue-custom-element'
Vue.use(vueCustomElement)

import { icons } from './icons'
import VueGlobalVar from 'vue-global-var'
Vue.use(VueGlobalVar, {
  globals: {
    $icons: icons
  }
})

// Vuex
import {store} from './store'
App.store = store

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.customElement('vue-list-view', App)
